export class Bodega {

    public id:number;
    public codigoBodega:string;
    public nombre:string;
    public referencia1:string;
    public referencia2:string;
    public referencia3:string;    

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/bodega.ts